/* assets/sham-tooltip.js */

if (!customElements.get('sham-tooltip')) {
  class ShamTooltip extends HTMLElement {
    constructor() {
      super();
      this.boundOnClick = this.onClick.bind(this);
      this.boundOnDocumentClick = this.onDocumentClick.bind(this);
      this.boundOnMouseEnter = this.onMouseEnter.bind(this);
      this.boundOnMouseLeave = this.onMouseLeave.bind(this);
      this.boundOnKeydown = this.onKeydown.bind(this);
    }

    connectedCallback() {
      this.addEventListener('click', this.boundOnClick);
      this.addEventListener('keydown', this.boundOnKeydown);
      document.addEventListener('click', this.boundOnDocumentClick);

      if (this.hasAttribute('data-hover')) {
        this.addEventListener('mouseenter', this.boundOnMouseEnter);
        this.addEventListener('mouseleave', this.boundOnMouseLeave);
      }
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.boundOnClick);
      this.removeEventListener('keydown', this.boundOnKeydown);
      document.removeEventListener('click', this.boundOnDocumentClick);
      this.removeEventListener('mouseenter', this.boundOnMouseEnter);
      this.removeEventListener('mouseleave', this.boundOnMouseLeave);
    }

    onKeydown(e) {
      if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
        e.preventDefault();
        this.onClick(e);
        return;
      }
      if (e.key === 'Escape') this.classList.remove('is-active');
    }

    onClick(e) {
      e.stopPropagation();
      const isActive = this.classList.contains('is-active');

      // Close all other tooltips first
      document.querySelectorAll('sham-tooltip.is-active').forEach(tooltip => {
        tooltip.classList.remove('is-active');
      });

      // Toggle current
      if (!isActive) {
        this.classList.add('is-active');
      }
    }

    onDocumentClick() {
      if (this.classList.contains('is-active')) {
        this.classList.remove('is-active');
      }
    }

    onMouseEnter() {
      this.classList.add('is-active');
    }

    onMouseLeave() {
      this.classList.remove('is-active');
    }
  }

  customElements.define('sham-tooltip', ShamTooltip);
}
